import { CameraControls, CameraControlsImpl } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
import { Box3, Vector3 } from 'three'

import { useDebug } from '@hooks'

import { ParallaxCamera } from './ParallaxCamera'

export function CameraRig() {
  const debug = useDebug()
  const controls = useThree(s => s.controls)
  const viewport = useThree(s => s.viewport)

  useEffect(() => {
    const cameraControls = controls as CameraControlsImpl
    if (!cameraControls) return

    cameraControls.setBoundary(new Box3(new Vector3(-3, 0, -3), new Vector3(3, 1, 0)))
    cameraControls.setLookAt(0, 8, 12, 0, viewport.aspect < 1 ? -1 : 0, 0, true)
    cameraControls.dollyTo(viewport.aspect < 1 ? 18 : 12, true)
  }, [viewport, controls])

  return (
    <>
      <ParallaxCamera makeDefault fov={45} near={0.1} far={100} position={[0, 1, 1]} />
      <CameraControls
        makeDefault
        minDistance={8}
        maxDistance={25}
        mouseButtons={
          debug
            ? undefined
            : {
                left: CameraControlsImpl.ACTION.TRUCK,
                right: CameraControlsImpl.ACTION.TRUCK,
                middle: CameraControlsImpl.ACTION.DOLLY,
                wheel: CameraControlsImpl.ACTION.DOLLY,
              }
        }
        touches={
          debug
            ? undefined
            : {
                one: CameraControlsImpl.ACTION.NONE,
                two: CameraControlsImpl.ACTION.TOUCH_DOLLY_TRUCK,
                three: CameraControlsImpl.ACTION.TOUCH_DOLLY_TRUCK,
              }
        }
      />
    </>
  )
}
